// extracted by mini-css-extract-plugin
var _1 = "CalendarItemCardDetails-moduleCalendarItemCardDetails__AqsdL";
var _2 = "CalendarItemCardDetails-moduleaddress__w9rLW";
export { _1 as "CalendarItemCardDetails", _2 as "address" }
